import {
  useFloating,
  offset,
  flip,
  useInteractions,
  useDismiss,
  useRole,
  useClick,
} from "@floating-ui/react";
import { useState } from "react";
import EventItem from "../../../../../EventItem";
import { EventFragment } from "../../../../../../../../__generated__/graphql";
import { cn } from "../../../../../../../../lib/utils";

interface EventsTooltipProps {
  events: EventFragment[];
  children: React.ReactNode;
  className?: string;
}

export default function EventsTooltip({
  events,
  children,
  className,
}: EventsTooltipProps) {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: "right-start",
    middleware: [
      offset(-20),
      flip({
        fallbackPlacements: ["left-start", "right-start"],
      }),
    ],
  });

  const click = useClick(context, { toggle: true });
  const dismiss = useDismiss(context);
  const role = useRole(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ]);

  return (
    <>
      <div
        ref={refs.setReference}
        {...getReferenceProps()}
        className={cn("cursor-pointer flex select-none", className)}
      >
        {children}
      </div>

      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          {...getFloatingProps()}
          className="z-50 bg-dark border border-accent rounded-md shadow-lg p-2 max-w-sm"
        >
          <div className="flex flex-col gap-1">
            {events.map((event) => (
              <div
                key={event.id}
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                <EventItem event={event} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
